import React, { useEffect, useRef } from 'react';

import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { overlayKeyframeIn, overlayKeyframeOut } from '../constants';

const StyledSideSheetOverlay = styled.div`
  animation: ${({ hasMounted, isCollapsed }) => {
    if (isCollapsed && !hasMounted) {
      return null;
    } else if (isCollapsed) {
      return css`
        ${overlayKeyframeOut} .2s linear
      `;
    } else {
      return css`
        ${overlayKeyframeIn} .2s linear
      `;
    }
  }};
  background-color: transparent;
  height: inherit;
  left: 0;
  opacity: ${({ isCollapsed }) => (isCollapsed ? 0 : 1)};
  position: absolute;
  right: 0;
  width: inherit;
  z-index: ${({ isCollapsed, theme }) =>
    isCollapsed ? theme.zIndex.hidden.value : theme.zIndex.sideSheetOverlay.value};
`;

const SideSheetOverlay = ({ className = '', dataTestId = undefined, hasMounted, isCollapsed = true, ...other }) => {
  const didMountRef = useRef(false);
  useEffect(() => {
    didMountRef.current = true;
  }, []);
  return (
    <StyledSideSheetOverlay hasMounted={didMountRef.current} {...{ className, dataTestId, isCollapsed }} {...other} />
  );
};

SideSheetOverlay.propTypes = {
  /** Adds additional className to SideSheet to override styling */
  className: PropTypes.string,
  /** Id value used for testing */
  dataTestId: PropTypes.string,
  /** @ignore */
  hasMounted: PropTypes.bool,
  /** If true, component is collapsed */
  isCollapsed: PropTypes.bool,
};

export { SideSheetOverlay };
